function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 11C16.2089 11 15.4355 10.7654 14.7777 10.3259C14.1199 9.88635 13.6072 9.26164 13.3045 8.53074C13.0017 7.79983 12.9225 6.99556 13.0769 6.21964C13.2312 5.44372 13.6122 4.73098 14.1716 4.17157C14.731 3.61216 15.4437 3.2312 16.2196 3.07686C16.9956 2.92252 17.7998 3.00173 18.5307 3.30448C19.2616 3.60723 19.8864 4.11992 20.3259 4.77772C20.7654 5.43552 21 6.20888 21 7C21 8.473 19.667 13.14 17 21H15L17 11ZM7 11C6.20888 11 5.43552 10.7654 4.77772 10.3259C4.11992 9.88635 3.60723 9.26164 3.30448 8.53074C3.00173 7.79983 2.92252 6.99556 3.07686 6.21964C3.2312 5.44372 3.61216 4.73098 4.17157 4.17157C4.73098 3.61216 5.44372 3.2312 6.21964 3.07686C6.99556 2.92252 7.79983 3.00173 8.53074 3.30448C9.26164 3.60723 9.88635 4.11992 10.3259 4.77772C10.7654 5.43552 11 6.20888 11 7C11 8.473 9.667 13.14 7 21H5L7 11Z",
  fill: "#38B2AC"
});

var SvgQuoteRight = function SvgQuoteRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuoteRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quote-right.34ca7e27.svg";
export { ForwardRef as ReactComponent };